export default "__VITE_ASSET__DruGwRaA__"